const _ = require("lodash");
const {groupQueryFromContextWithoutOr} = require("../../../../enhancers/defaultObjects");
const {importantInputCorrespondences} = require("../../inputCorrespondence");

export const alertConfigurationFieldPath = [
    "tName",
    "timeWindow.id", "timeWindow.quantity", "timeWindow.period", "queryDates",
    "hasTimeInterval", "startTime", "endTime",
    "baseDay", "weekDay", "monthDay",
    "filterFields.filterObjectForMongo",
    "conditionGroups.conditions.id", "conditionGroups.conditions.conditionType.id", "conditionGroups.conditions.stream.id",
    "conditionGroups.conditions.source.id", "conditionGroups.conditions.source.dataType.isNumber", "conditionGroups.conditions.source.internalIdentifier", "conditionGroups.conditions.source.inputCorrespondenceByImportType.id",
    "conditionGroups.conditions.source2.id", "conditionGroups.conditions.source2.dataType.isNumber", "conditionGroups.conditions.source2.internalIdentifier", "conditionGroups.conditions.source2.inputCorrespondenceByImportType.id",
    "conditionGroups.conditions.source3.id", "conditionGroups.conditions.source3.dataType.isNumber", "conditionGroups.conditions.source3.internalIdentifier", "conditionGroups.conditions.source3.inputCorrespondenceByImportType.id",
    "conditionGroups.conditions.operator.id", "conditionGroups.conditions.operator.mongoSymbol", "conditionGroups.conditions.aggOperator.id", "conditionGroups.conditions.aggOperator.mongoOperator", "conditionGroups.conditions.condValue", "conditionGroups.conditions.condValues",
    "groupAxes.childOfAxisEntityName",
    "groupAxes.projectObjectForMongo", "groupAxes.groupIdObjectForMongo",
    "preGroupAxes.projectObjectForMongo", "preGroupAxes.groupIdObjectForMongo",
    "alertFields.alertEngineOrder.id", "alertFields.themeFieldPaths", "alertFields.preGroupObjectForMongo", "alertFields.themeFieldPath", "alertFields.denominatorThemeFieldPath",
    "alertFields.themeStreamId", "alertFields.denominatorThemeStreamId",
    "alertFields.condOperator.mongoSymbol", "alertFields.value", "alertFields.aggOperator.mongoOperator", "alertFields.preAggOperator.mongoOperator"
];

const datesQuery = (alertConf, delay) => {

    return {
        [importantInputCorrespondences.Date.internalIdentifier]: delay
            ? {
                $lt: alertConf.queryDates["$lt"].clone().subtract(delay * alertConf.timeWindow.quantity, alertConf.timeWindow.period).toDate(),
                $gte: alertConf.queryDates["$gte"].clone().subtract(delay * alertConf.timeWindow.quantity, alertConf.timeWindow.period).toDate()
            }
            : {
                $lt: alertConf.queryDates["$lt"].toDate(),
                $gte: alertConf.queryDates["$gte"].toDate()
            }
    }
}

const datesExpressionQuery = (alertConf, delay) => {
    return {
        $and: [
            {
                $lt: [
                    `$${importantInputCorrespondences.Date.internalIdentifier}`,
                    delay
                        ? alertConf.queryDates["$lt"].clone().subtract(delay * alertConf.timeWindow.quantity, alertConf.timeWindow.period).toDate()
                        : alertConf.queryDates["$lt"].toDate()
                ]
            },
            {
                $gte: [
                    `$${importantInputCorrespondences.Date.internalIdentifier}`,
                    delay
                        ? alertConf.queryDates["$gte"].clone().subtract(delay * alertConf.timeWindow.quantity, alertConf.timeWindow.period).toDate()
                        : alertConf.queryDates["$gte"].toDate()
                ]
            },
        ]
    }
}

const groupObjectForMongo = (alertConf, alertField, index) => ['themeFieldPath', 'denominatorThemeFieldPath'].reduce(
    (acc, fieldPath) => {
        const themeFieldPath = alertField[fieldPath]
        if(!themeFieldPath) return acc
        const fieldPathWithPrefix = fieldPath === 'themeFieldPath'
            ? `${index}-numerator-${themeFieldPath}`
            : `${index}-denominator-${themeFieldPath}`

        const delay = fieldPath === 'themeFieldPath'
            ? alertField.numeratorDelay
            : alertField.denominatorDelay

        return Object.assign(
            acc,
            {
                [fieldPathWithPrefix.replace(/\./g,' ')]: {
                    [alertField.aggOperator.mongoOperator]: {
                        $cond: [
                            datesExpressionQuery(alertConf, delay),
                            `$${themeFieldPath}`,
                            0
                        ]
                    }

                }
            }
        )
    },
    {}
);

const projectObjectForMongo = (alertField, index) => ['themeFieldPath', 'denominatorThemeFieldPath'].reduce(
    (acc, fieldPath) => {
        const themeFieldPath = alertField[fieldPath]
        if(!themeFieldPath) return acc
        const fieldPathWithPrefix = fieldPath === 'themeFieldPath'
            ? `${index}-numerator-${themeFieldPath}`
            : `${index}-denominator-${themeFieldPath}`
        return _.setWith(acc, fieldPathWithPrefix, `$${fieldPathWithPrefix.replace(/\./g,' ')}`, Object) //Object is the customizer to avoid setting number keys as arrays
    }, {}
);

export const groupIdForMongoQuery = axes => axes.reduce(
    (acc, groupAxis) => Object.assign(acc, groupAxis.groupIdObjectForMongo),
    {}
)

export const sortObjectForMongoQuery = axes => axes.reduce(
    (acc, groupAxis) => Object.assign(acc, groupAxis.sortObjectForMongo),
    {}
)

const roundRatios = alertFields => alertFields.reduce((acc, alertField, i) => {
    if (!alertField.denominatorThemeFieldPath) return acc;
    return Object.assign(
        acc,
        {
            [`ratio${i}`]: {
                $round: [`$ratio${i}`, 4 ]
            }
        }
    );
}, {});

const ratiosProjection = alertFields => alertFields.reduce((acc, alertField, i) => {
    if (!alertField.denominatorThemeFieldPath) return acc;
    return Object.assign(
        acc,
        {
            [`ratio${i}`]: {
                $cond: [
                    { $eq: [`$${alertField.denominatorThemeFieldPath}`, 0 ] },
                    0,
                    {$divide: [
                        `$${alertField.themeFieldPath}`,
                        `$${alertField.denominatorThemeFieldPath}`
                        ]
                    }
                ]
            }
        }
    );
}, {});

const ratiosProjectionAfterAggregation = alertFields => alertFields.reduce((acc, alertField, i) => {
    if (!alertField.denominatorThemeFieldPath) return acc;
    return Object.assign(
        acc,
        {
            [`ratio${i}`]: {
                $cond: [
                    { $eq: [`$${i}-denominator-${alertField.denominatorThemeFieldPath}`, 0 ] },
                    0,
                    {$divide: [
                            `$${i}-numerator-${alertField.themeFieldPath}`,
                            `$${i}-denominator-${alertField.denominatorThemeFieldPath}`
                        ]
                    }
                ]
            }
        }
    );
}, {});

// Each indicator's threshold is absent-tolerant: a line passes an indicator's clause
// when it does not carry that indicator's theme(s) OR it satisfies the threshold. This
// lets a rule mix indicators whose themes live on different elemData line types without
// filtering every line out.
const matchConditions = alertFields => {
    const clauses = alertFields.map((alertField, i) => {
        const isRatio = !!alertField.denominatorThemeFieldPath
        const matchKey = isRatio ? `ratio${i}` : alertField.themeFieldPath
        const condition = {
            [matchKey]: {
                [`$${alertField.condOperator.mongoSymbol}`]: alertField.value
            }
        }
        const themeAbsent = isRatio
            ? {$or: [
                {[alertField.themeFieldPath]: {$exists: false}},
                {[alertField.denominatorThemeFieldPath]: {$exists: false}},
            ]}
            : {[alertField.themeFieldPath]: {$exists: false}}
        return {$or: [themeAbsent, condition]}
    })
    return clauses.length === 0
        ? {}
        : clauses.length === 1
            ? clauses[0]
            : {$and: clauses}
};

const matchConditionsAfterAggregation = alertFields => alertFields
    .reduce((acc, alertField, i) => {
        if(alertField.alertEngineOrder.id === "aggregationRatioCondition") {
            const matchKey = alertField.denominatorThemeFieldPath ? `ratio${i}` : i + '-numerator-' + alertField.themeFieldPath;
            return Object.assign(
                acc,
                {[matchKey]: {
                        [`$${alertField.condOperator.mongoSymbol}`]: alertField.value
                    }}
            )
        }
        return acc
}, {});

export const createAggregationPipeline = (alertConfiguration, context) => {
    const projectGroupAxes = alertConfiguration.groupAxes.reduce(
        (acc, groupAxis) => Object.assign(acc, _.mapValues(groupAxis.projectObjectForMongo, () => 1)),
        {}
    );

    const projectAlertFields = _(alertConfiguration.alertFields)
        .flatMap("themeFieldPaths")
        .reduce(
            (acc, fieldPath) => Object.assign(acc, {[fieldPath]: 1}),
            {}
        );

    const projectAlertFieldsAfterAggregation = _(alertConfiguration.alertFields)
        .flatMap( (alertField, index) => {
            return _.compact(
                ['themeFieldPath', 'denominatorThemeFieldPath'].map(themeFieldPath => {
                    const prefix = themeFieldPath === 'themeFieldPath'
                        ? index + '-numerator-'
                        : index + '-denominator-'
                    return alertField[themeFieldPath] && prefix + alertField[themeFieldPath]
                })
            )
        })
        .reduce(
            (acc, fieldPath) => Object.assign(acc, {[fieldPath]: 1}),
            {}
        );

    const fieldsBeforeAggregation = alertConfiguration.alertFields.filter(
        alertField => alertField.alertEngineOrder.id === "ratioConditionAggregation"
    );

    const fieldsAfterAggregation = alertConfiguration.alertFields.filter(
        alertField => alertField.alertEngineOrder.id === "aggregationRatioCondition"
    );

    const groupAxesExist = groupAxes => groupAxes.reduce(
        (acc, groupAxis) => Object.assign(acc, {[groupAxis.code]: {$exists: true}}), {}
    );

    const filterFieldsConditions = filterFields => filterFields.reduce(
        (acc, filter) => Object.assign(acc, filter.filterObjectForMongo), {}
    );

    const getQuery = conditions => {
        return conditions.reduce((acc, condition) => {
            const conditionTypeId = _.get(condition, 'conditionType.id')
            const isApplyConditionType = conditionTypeId === "applyCondition"
            const isApplyComparisonType = conditionTypeId === "applyComparison"
            const isApplyAttributeOperationConditionType = conditionTypeId === "applyAttributeOperationCondition"
            const isNumber = _.get(condition, 'source.dataType.isNumber')

            let leftOperand;

            if (isApplyConditionType || isApplyComparisonType) {
                leftOperand = `$${condition.source.internalIdentifier}`
            } else if (isApplyAttributeOperationConditionType && condition.aggOperator.mongoOperator === "$divide") {
                leftOperand = {
                    $cond: [
                        { $ne: [ `$${condition.source3.internalIdentifier}`, 0 ] },
                        {
                            $divide: [
                                `$${condition.source.internalIdentifier}`,
                                `$${condition.source3.internalIdentifier}`
                            ]
                        },
                        0
                    ]
                };
            } else if (isApplyAttributeOperationConditionType && condition.aggOperator.mongoOperator === "$average") {
                leftOperand = {
                    $divide: [
                        {
                            $add: [
                                `$${condition.source.internalIdentifier}`,
                                `$${condition.source3.internalIdentifier}`
                            ]
                        },
                        2
                    ]
                };
            }else if (isApplyAttributeOperationConditionType) {
                leftOperand = {
                    [condition.aggOperator.mongoOperator]: [
                        `$${condition.source.internalIdentifier}`,
                        `$${condition.source3.internalIdentifier}`
                    ]
                };
            } else {
                console.log(`Unsupported condition type: ${conditionTypeId}`)
                return acc
            }

            const rightOperand = isApplyComparisonType
                ? `$${condition.source2.internalIdentifier}`
                : ["000000000000000000000018", "000000000000000000000019", "000000000000000000000020", "000000000000000000000021"].includes(condition.operator.id)
                    ? condition.condValues.split(';').map(value => isNumber ? Number(value) : value)
                    : isNumber ? Number(condition.condValue) : condition.condValue

            let query

            if(condition.operator.mongoSymbol === 'regexMatch') {
                const regex = isApplyComparisonType
                    ? rightOperand
                    : rightOperand.join("|")
                query = {
                    $regexMatch: {
                        input: leftOperand,
                        regex: regex,
                        options: 'i'
                    }
                }
            } else if(condition.operator.mongoSymbol === 'negatedRegexMatch') {
                const regex = isApplyComparisonType
                        ? rightOperand
                        : rightOperand.join("|")
                query = {
                    $not: {
                        $regexMatch: {
                            input: leftOperand,
                            regex,
                            options: "i"
                        }
                    }
                }
            } else {
                query = {
                    [`$${condition.operator.mongoSymbol}`]: [leftOperand, rightOperand]
                }
            }

            if(acc["$expr"]) {
                if(acc["$expr"]["$and"]) {
                    return {
                        "$expr": {
                            "$and": [
                                ...acc["$expr"]["$and"],
                                query
                            ]
                        }
                    }
                }
                return {
                    "$expr": {
                        "$and": [
                            acc["$expr"],
                            query
                        ]
                    }
                }
            }
            return {"$expr": query}
        }, {})
    }

    const conditionQueryForStream = streamId => {
        const conditionGroupsQueries = _(alertConfiguration.conditionGroups).map(conditionGroup => {
            const conditions = conditionGroup.conditions.filter(condition => _.get(condition, "stream.id") === streamId)
            if(!conditions.length) return null
            return getQuery(conditions)
        }).compact().value()
        return !conditionGroupsQueries.length
            ? {}
            : conditionGroupsQueries.length === 1
                ? conditionGroupsQueries[0]
                : {$or: conditionGroupsQueries}
    }

    // Existence query for a single indicator: its numerator (and, for a ratio, its
    // denominator) theme field must be present, within the relevant date window and
    // stream condition(s). Theme fields that share the same (delay, streamId) are AND-ed
    // (they can coexist on one elemData line); different (delay, streamId) buckets are
    // OR-ed, because a single line cannot fall in two disjoint date windows.
    const themeExistenceForField = alertField => {
        const objects = alertField.denominatorThemeFieldPath
            ? [
                {themePath: alertField.themeFieldPath, delay: 0, streamId: alertField.themeStreamId},
                {themePath: alertField.denominatorThemeFieldPath, delay: alertField.denominatorDelay, streamId: alertField.denominatorThemeStreamId}
            ]
            : [{themePath: alertField.themeFieldPath, delay: 0, streamId: alertField.themeStreamId}]

        const grouped = _.groupBy(objects, obj => `${obj.delay}::${obj.streamId}`)

        const subQueries = _.map(grouped, group => {
            const {delay, streamId} = group[0]
            return group.reduce((acc, obj) => {
                return {
                    ...acc,
                    [obj.themePath]: {$exists: true},
                }
            }, {
                ...datesQuery(alertConfiguration, delay),
                ...conditionQueryForStream(streamId)
            })
        })

        return subQueries.length === 1 ? subQueries[0] : {$or: subQueries}
    }

    // One branch per indicator, OR-ed together: an elemData line is kept when it carries
    // the theme(s) of at least one indicator. Indicators whose themes land on different
    // line types no longer filter each other out.
    const themesNotEmpty = alertFields => {
        const queries = alertFields.map(themeExistenceForField)
        return queries.length === 1 ? queries[0] : {$or: queries}
    }

    const timeIntervalPipeline = alertConfiguration.hasTimeInterval
        ? [
            {
                $addFields: {
                    timeString: { $dateToString: { format: "%H:%M", date: "$date" } }
                }
            },
            {
                $match: {
                    timeString: { $gte: alertConfiguration.startTime, $lte: alertConfiguration.endTime }
                }
            }
        ]
        : []

    const groupByPipeline = !!alertConfiguration.preGroupAxes.length
        ? [
            {$group: Object.assign(
                    {
                        _id: groupIdForMongoQuery(alertConfiguration.preGroupAxes),
                        date: {$first: "$date"}
                    },
                    alertConfiguration.groupAxes.reduce(
                        (acc, groupAxis) => Object.assign(acc,{[groupAxis.code]: {$first: `$${groupAxis.code}`} } ),
                        {}
                    ),
                    ..._.map(alertConfiguration.alertFields, alertField => alertField.preGroupObjectForMongo)
                )},
            {$project: Object.assign(
                    {date: 1},
                    projectGroupAxes,
                    alertConfiguration.alertFields.reduce((acc, alertField) => {
                        return {
                            ...acc,
                            ...['themeFieldPath', 'denominatorThemeFieldPath'].reduce((innerAcc, fieldPath) => {
                                if(!alertField[fieldPath]) return innerAcc
                                return {...innerAcc, [alertField[fieldPath]]: `$${alertField[fieldPath].replace(/\./g,' ')}`}
                                },{}
                            )
                        }
                    }, {}),
                )},
        ]
        : []

    const aggregation = [
        {$match: Object.assign(
                groupQueryFromContextWithoutOr(context),
                themesNotEmpty(alertConfiguration.alertFields),
                filterFieldsConditions(alertConfiguration.filterFields),
                groupAxesExist(alertConfiguration.groupAxes),
            )},
        ...timeIntervalPipeline,
        ...groupByPipeline,
        {$project: Object.assign(
                {_id: 0, date: 1},
                projectGroupAxes,
                projectAlertFields,
                ratiosProjection(fieldsBeforeAggregation)
            )},
        {$project: Object.assign(
                {date: 1},
                projectGroupAxes,
                projectAlertFields,
                roundRatios(fieldsBeforeAggregation),
            )},
        {$match: matchConditions(fieldsBeforeAggregation)},
        {$group: Object.assign(
                {
                    _id: groupIdForMongoQuery(alertConfiguration.groupAxes),
                    lineCount: { $sum: 1 }
                },
                ..._.map(alertConfiguration.alertFields, (alertField, index) => groupObjectForMongo(alertConfiguration, alertField, index))
            )},
        {$project: Object.assign(
                {
                    _id: 0,
                    lineCount: 1
                },
                ...alertConfiguration.groupAxes.map(groupAxis => groupAxis.projectObjectForMongo),
                _.defaultsDeep(...alertConfiguration.alertFields.map(projectObjectForMongo))
            )},
        {$project: Object.assign(
                {lineCount: 1},
                projectGroupAxes,
                projectAlertFieldsAfterAggregation,
                ratiosProjectionAfterAggregation(fieldsAfterAggregation)
            )},
        {$match: matchConditionsAfterAggregation(alertConfiguration.alertFields)},
        {$project: Object.assign(
                {lineCount: 1},
                projectGroupAxes,
                projectAlertFieldsAfterAggregation
            )}
    ]
    return aggregation
};
